import React, { Component, useState } from 'react';
import { FloatingLabel, Form, Modal, Stack } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import FtueButton from '../Ftue/FtueButton';
import { LOGO_URL } from '../../Settings';
import { useLocalDisplayName } from '../../hooks/useLocalDisplayName';

import './menus.css';


// CC_CONFIG_MENU_AUDIT (2026-06-08): the TextureQualityButton toggle was
// removed. It defaulted to OFF (account.high_quality_textures default
// False, accounts/models.py:47), so the menu literally read "Textures
// are Low Quality" — user-hostile. The high_quality_textures FIELD stays
// (read by GamePlayer2d, TradelaneSelector, CompetitorBoard,
// PlayerOrbits2d to pick texture sets); only the player-facing toggle is
// gone. With no toggle, quality is frozen at the stored value — see the
// LOUD texture-default-flip proposal in INGAME_CONFIG_REVIEW.md (a model
// default change Michael must green-light, NOT taken by this CC). The
// BE 'High Quality Textures' branch in game_settings.py is now a
// senderless receiver — reported, not removed (no-blind-deletes).


class VolumeControl extends Component {

    constructor(props) {
        super(props);
        this.app = this.props.app;
        this.universe = this.app.universe;
        this.authenticator = this.app.state.authenticator;
        this.account = this.authenticator.account;
        this.state = { volume: this.account.volume };
    }

    onChange = (event) => {
        let value = event.target.value;
        this.setState({ volume: value });
        this.account.volume = value;
        this.setVolume(value);
    };

    setVolume = (value) => {
        let typeName = 'Configuration';
        let packageValue = { type: 'Volume', data: { value: value } };
        this.authenticator.sendMessage(typeName, packageValue);
    };

    render() {
        return <Form style={{ color: 'white' }}>
            <Form.Label>Volume {Math.trunc(this.state.volume * 100)}%</Form.Label>
            <Form.Range
                value={this.state.volume}
                onChange={this.onChange}
                min="0" max="1"
                step="0.01"
            />
        </Form>;
    }

}

// Function component so it can read the canonical local display name
// off the Discord context via useLocalDisplayName. The input's initial
// value is the resolved display name (never the discord_<snowflake>
// username — falls to '' when there is literally no candidate). The
// editable source the user is asked to set remains account.player_name;
// on-change behavior is unchanged (writes player_name + sends the
// Configuration package).
export function DisplayName({ app }) {
    const authenticator = app.state.authenticator;
    const account = authenticator.account;
    const initialName = useLocalDisplayName(app);
    const [value, setValue] = useState(initialName || '');

    const onChange = (event) => {
        const nextValue = event.target.value;
        setValue(nextValue);
        account.player_name = nextValue;
        const typeName = 'Configuration';
        const packageValue = {
            type: 'Player Name', data: { value: nextValue },
        };
        authenticator.sendMessage(typeName, packageValue);
    };

    return <Form style={{ color: 'black' }}>
        <FloatingLabel
            controlId="floatingInput"
            label="Display Name"
            className="mb-3"
        >
            <Form.Control
                type="text"
                placeholder="Your Displayed Name"
                onChange={onChange}
                value={value}
            />
        </FloatingLabel>
    </Form>;
}


export default class ConfigurationMenu extends Component {

    constructor(props) {
        super(props);
        this.state = { show: false };
        props.app.configurationMenu = this;
    }

    show = () => {
        this.setState({ show: true });
    };


    handleClose = () => {
        this.setState({ show: false });
    };

    // CC_MAIN_MENU_BUTTON_DEADWIRE (2026-06-08): the Main Menu button
    // used to call this.props.changeToMenu('main'), but BottomMenu (the
    // only live mount path — MainMenuShell, GamePlayer2dMenu,
    // ManagerMenu) threads NO changeToMenu, so the click threw
    // TypeError. Re-point at the quick-router-event '/' dispatch every
    // working nav already uses (MainMenu's sibling buttons, EscapeMenu's
    // Save/Abandon). A plain window event needs no prop threading and is
    // StrictMode- / router-6.3-safe (no navigate in any deps). Close the
    // modal first so it doesn't linger over the Main Menu route.
    handleMainMenu = () => {
        this.handleClose();
        window.dispatchEvent(
            new CustomEvent('quick-router-event', { detail: '/' }));
    };

    render() {
        return <>
            <Modal show={this.state.show}
                   onHide={this.handleClose}
                   className={'configuration-modal'}
                   dialogClassName='configuration-modal'
                   contentClassName='configuration-modal'
            >
                <Modal.Header className={'configuration-modal'}>
                    <Modal.Title>HSH Configuration</Modal.Title>
                    <button type="button" className="btn-close btn-close-white" aria-label="Close"
                            onClick={this.handleClose}
                    />
                </Modal.Header>

                <Modal.Body className={'configuration-modal'}>

                    <Container id={'configuration-menu-container'} className={'menu-container'}>
                        <Stack gap={3} className="button-stack">
                            <div style={{ display: 'flex', alignSelf: 'center' }}>
                                <img
                                    src={LOGO_URL}
                                    width={'150px'}
                                    height={'auto'}
                                    alt={'logo'}
                                />
                            </div>
                            <DisplayName {...this.props}/>
                            <VolumeControl {...this.props}/>
                            <FtueButton {...this.props}/>

                            <Button variant={'hex'}
                                    onClick={this.props.app.forceLogoutButton}
                            >
                                Logout
                            </Button>
                            <Button variant={'seed'}
                                    onClick={this.handleMainMenu}>
                                Main Menu
                            </Button>
                        </Stack>
                    </Container>
                </Modal.Body>
            </Modal>
        </>;
    }

}
